import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/tienda.css';
import '../styles/combos-home.css';
import { getAllCombos } from '../services/catalogApi';

const CombosHome = ({ excluirComboId, kicker = 'Ahorra más', titulo = 'Combos' }) => {
  const [combos, setCombos] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    getAllCombos()
      .then(setCombos)
      .catch(() => setCombos([]))
      .finally(() => setLoading(false));
  }, []);

  const combosVisibles = excluirComboId != null
    ? combos.filter((combo) => String(combo.comboId) !== String(excluirComboId))
    : combos;

  if (loading || combosVisibles.length === 0) return null;

  return (
    <section className="seccion-productos">
      <div className="linea-header">
        <div>
          <p className="linea-kicker">{kicker}</p>
          <h2 className="linea-h2">{titulo}</h2>
        </div>
      </div>
      <hr className="linea-hr" />

      <div className="grid-productos">
        {combosVisibles.map((combo) => {
          const fotoRaw = combo.comboFoto;
          const foto = (Array.isArray(fotoRaw) ? fotoRaw[0] : fotoRaw) || '/img/default.jpg';
          const precioFinal = Math.max(0, combo.comboPrecio - combo.comboDescuento);
          const porcentajeDescuento = combo.comboDescuento > 0 && combo.comboPrecio > 0
            ? Math.round((combo.comboDescuento / combo.comboPrecio) * 100)
            : 0;

          return (
            <div
              key={combo.comboId}
              className="producto-carta combo-carta"
              onClick={() => navigate(`/combos/${combo.comboId}`)}
            >
              <div className="carta-media">
                {porcentajeDescuento > 0 && (
                  <span className="carta-badge">-{porcentajeDescuento}%</span>
                )}
                <img src={foto} alt={combo.comboNombre} className="producto-foto" loading="lazy" />
              </div>
              <div className="producto-info">
                <h3>{combo.comboNombre}</h3>
                <div className="precio-accion">
                  <div className="precios">
                    {combo.comboDescuento > 0 ? (
                      <p className="precio-linea">
                        <span className="precio-descuento">${precioFinal.toFixed(2)}</span>
                        <span className="precio-original">${combo.comboPrecio.toFixed(2)}</span>
                      </p>
                    ) : (
                      <p className="precio-linea">
                        <span className="precio-normal">${precioFinal.toFixed(2)}</span>
                      </p>
                    )}
                  </div>
                  <button
                    className="button-add compact"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/combos/${combo.comboId}`);
                    }}
                  >
                    Ver combo
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default CombosHome;
